import React from 'react'
import { useSelector } from 'react-redux'
import { NotificationItem } from './partials/notification-item'
import { SectionTitle } from './partials/section-title'
import { useWizard } from 'react-use-wizard'
import { Button } from 'web/src/app/root/components/common'

export const UserNotificationsSettings = ({
    userNotificationsSettings,
    setNotificationsSettingsHandler
}) => {
    const { locale } = useSelector(state => state.main)
    const { nextStep } = useWizard()

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '82vh'
            }}
        >
            <div
                style={{
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <div>
                    <SectionTitle
                        title={locale.settings.notificationsChannels}
                    />
                    <NotificationItem
                        label={locale.settings.pushNotificationsEnabled}
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'push_notification_enabled',
                                checked
                            })
                        }
                        checked={
                            userNotificationsSettings.push_notification_enabled
                        }
                    />
                    <NotificationItem
                        label={locale.settings.emailNotificationsEnabled}
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'mail_notification_enabled',
                                checked
                            })
                        }
                        checked={
                            userNotificationsSettings.mail_notification_enabled
                        }
                    />
                    <SectionTitle title={locale.settings.notificationsEvents} />
                    <NotificationItem
                        label={
                            locale.settings.trapsTriggeredNotificationsEnabled
                        }
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'notificate_triggered',
                                checked
                            })
                        }
                        checked={userNotificationsSettings.notificate_triggered}
                    />
                    <NotificationItem
                        label={
                            locale.settings
                                .trapsInactiveemailNotificationsEnabled
                        }
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'notificate_inactive',
                                checked
                            })
                        }
                        checked={userNotificationsSettings.notificate_inactive}
                    />
                    <NotificationItem
                        label={locale.settings.batteryEmptyNotificationsEnabled}
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'notificate_battery',
                                checked
                            })
                        }
                        checked={userNotificationsSettings.notificate_battery}
                    />
                    <NotificationItem
                        label={locale.settings.batterySetupNotificationsEnabled}
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'notificate_trap_set',
                                checked
                            })
                        }
                        checked={userNotificationsSettings.notificate_trap_set}
                    />
                    <NotificationItem
                        label={locale.settings.trapOnlineNotificationsEnabled}
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'notificate_back_online',
                                checked
                            })
                        }
                        checked={
                            userNotificationsSettings.notificate_back_online
                        }
                    />
                    <NotificationItem
                        label={
                            locale.settings
                                .unstableConnectionNotificationsEnabled
                        }
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'notificate_unstable_wifi',
                                checked
                            })
                        }
                        checked={
                            userNotificationsSettings.notificate_unstable_wifi
                        }
                    />
                    <NotificationItem
                        label={locale.settings.baitLowNotificationsEnabled}
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'notificate_bait_low',
                                checked
                            })
                        }
                        checked={userNotificationsSettings.notificate_bait_low}
                    />
                    <NotificationItem
                        label={
                            locale.settings
                                .activityThresholdReachedNotificationsEnabled
                        }
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name: 'notificate_activity_threshold_reached',
                                checked
                            })
                        }
                        checked={
                            userNotificationsSettings.notificate_activity_threshold_reached
                        }
                    />
                    <NotificationItem
                        label={
                            locale.settings
                                .baitLowAndActivityThresholdReachedNotificationsEnabled
                        }
                        onClick={(_, checked) =>
                            setNotificationsSettingsHandler({
                                name:
                                    'notificate_bait_low_and_activity_threshold_reached',
                                checked
                            })
                        }
                        checked={
                            userNotificationsSettings.notificate_bait_low_and_activity_threshold_reached
                        }
                    />
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 'auto',
                    padding: '20px 0'
                }}
            >
                <Button onClick={nextStep}>
                    {locale.userManagement.nextStep}
                </Button>
            </div>
        </div>
    )
}
